import { BZG_MODAL_DATA, BzgModalRef } from 'bz-genome-angular';
import { Component, Inject } from '@angular/core';


@Component({
  selector: 'pendingChangesConnectAlert',
  template: `
    <bzg-modal-header>
  <span class="bzg-modal__header__title bz-color--neutral-500">
      <svg class="bz-icon-svg bz-icon-svg--16 bz-icon-color--warning">
                  <use href="#icon-warning"></use>
                </svg>
    {{ 'GLOBAL.CONFIRMATION' | translate }}</span>
    </bzg-modal-header>
    <bzg-modal-content class="bmc-delete-alert__body">
      {{data.message ? data.message : 'GLOBAL.PENDING_CHANGES' | translate }}
    </bzg-modal-content>
    <bzg-modal-footer class="bmc-delete-alert__footer">
      <bzg-button-secondary class="bz-space--inline-m" (click)="close()" color="warning">{{ 'GLOBAL.DISCARD' | translate }}</bzg-button-secondary>
      <bzg-button-primary (click)="save()" color="warning">{{ 'GLOBAL.SAVE' | translate }}</bzg-button-primary>
    </bzg-modal-footer>
  `,
  styles: ['.bzg-modal__header__title {display: flex; justify-content: center; align-items: center} .bz-icon-svg {margin-right: 8px} .bmc-delete-alert__body {text-align: center} p {margin: 0}']
})
export class PendingChangesConnectAlertComponent {
  constructor(public modalComponentRef: BzgModalRef,
    @Inject(BZG_MODAL_DATA) public data: { message: string }) { }

  close() {
    this.modalComponentRef.close();
  }

  save() {
    this.modalComponentRef.close('save');
  }
}
